// Normalize stored HTML through Quill's supported formats before displaying it.
export function renderQuillComment(quill, content, { stripWhiteBackground = false } = {}) {
  // This overload handles the different convert signatures in Quill 1 and 2.
  quill.clipboard.dangerouslyPasteHTML(content || "", "silent");
  if (stripWhiteBackground) {
    // Clipboard HTML can carry a white background on each inline fragment.
    // Remove that presentation attribute after Quill has normalized the HTML.
    const delta = quill.getContents();
    let changed = false;
    const ops = delta.ops.map(op => {
      const background = String(op.attributes?.background || "").replace(/\s/g, "");
      if (!/^(?:white|#fff|#ffffff|#ffff|#ffffffff|rgb\(255,255,255\)|rgba\(255,255,255,(?:1(?:\.0+)?|100%)\))$/i.test(background)) return op;
      changed = true;
      const attributes = { ...op.attributes };
      delete attributes.background;
      const cleaned = { ...op };
      if (Object.keys(attributes).length) cleaned.attributes = attributes;
      else delete cleaned.attributes;
      return cleaned;
    });
    if (changed) quill.setContents({ ops }, "silent");
  }
  return quill.root.innerHTML;
}
